import { render } from "./KonfirmHapusItemCartModal.vue?vue&type=template&id=38e30ad4&scoped=true"
import script from "./KonfirmHapusItemCartModal.vue?vue&type=script&lang=js"
export * from "./KonfirmHapusItemCartModal.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-38e30ad4"

export default script